const EVENT_BROADCAST = 'cf-ads-user-interaction';

let engaged = false;
const pending = new Set();
let listenersAttached = false;
const removers = [];

function flushPending() {
  pending.forEach((fn) => {
    try {
      fn();
    } catch {}
  });
  pending.clear();
}

function unlock() {
  if (engaged) return;
  engaged = true;
  removers.splice(0).forEach((off) => off());
  listenersAttached = false;
  flushPending();
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(EVENT_BROADCAST));
  }
}

function attachListeners() {
  if (typeof window === 'undefined' || listenersAttached || engaged) return;
  listenersAttached = true;

  const add = (type, options = {}) => {
    const opts = { capture: false, ...options };
    const handler = () => unlock();
    window.addEventListener(type, handler, opts);
    removers.push(() => window.removeEventListener(type, handler, opts));
  };

  add('scroll', { passive: true });
  add('pointerdown', { passive: true });
  add('touchstart', { passive: true });
  add('wheel', { passive: true });
  add('keydown');
  add('mousemove', { passive: true });
}

export function subscribeAdsUserInteraction(callback) {
  if (typeof window === 'undefined') {
    return () => {};
  }
  if (engaged) {
    queueMicrotask(() => callback());
    return () => {};
  }
  pending.add(callback);
  attachListeners();
  return () => pending.delete(callback);
}

export function hasAdsUserInteracted() {
  return engaged;
}

export { EVENT_BROADCAST as ADS_USER_INTERACTION_EVENT };
